import { CommonModule } from '@angular/common';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { MdbModalRef } from 'src/lib/mdb5-adapted/public-api';
import { NgxPaginationModule, PaginationInstance } from 'ngx-pagination';
import { AppUtilityService } from 'src/app/app-utility.service';
import { LmsModalFrameComponent } from '../../ui/lms-modal-frame/lms-modal-frame.component';

async function loadXLSX() {
  const XLSX = await import('xlsx');
  return XLSX;
}

@Component({
  selector: 'app-branch-stats-report',
  templateUrl: './branch-stats-report.component.html',
  styleUrls: ['./branch-stats-report.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule, NgxPaginationModule, LmsModalFrameComponent],
})
export class BranchStatsReportComponent {
  statsList: any[] = [];
  title = 'export-excel';
  fileName = '';
  @ViewChild('TABLE') table: ElementRef;
  dataSource = this.statsList;
  config: PaginationInstance = {
    id: 'pager',
    itemsPerPage: 15,
    currentPage: 1,
  };

  constructor(public global_utility: AppUtilityService, public dialogRef: MdbModalRef<BranchStatsReportComponent>) {}

  exportLoansToExcel(): void {
    this.title = 'export-excel';
    this.fileName = `Branch Report_${new Date()}.xlsx`;
    this.global_utility.startLoading('Exporting data to Excel.');
    loadXLSX()
      .then((XLSX) => {
        const ws = XLSX.utils.table_to_sheet(this.table.nativeElement);

        /* generate workbook and add the worksheet */

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

        /* save to file */

        XLSX.writeFile(wb, this.fileName);
        XLSX.writeFile(wb, this.fileName);
        this.global_utility.stopLoading();
      })
      .catch((err) => {
        this.global_utility.stopLoading();
        this.global_utility.error('Failed to import Excel:', err);
      });
  }

getStatusRowClass(status: string): string {
  return (status ?? '').toLowerCase().replace(/\s+/g, '-');
}

  close() {
    this.dialogRef.close();
  }
}
